import { Component, OnInit, Input } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  standalone: false,
})
export class NotificationComponent implements OnInit {
  constructor(public generalService: GeneralService) {}

  @Input() notifications: any[] = []; // inicializado como array vacío

  ngOnInit(): void {}
}
